import NIconComponent from "./NIcon";

const NIcon = {
    install:function(Vue) {
        Vue.component('n-icon',NIconComponent)
    }
}
export default NIcon